"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalSQLite = void 0;
class GlobalSQLite {
    constructor() {
        this.secret = 'sqlite secret';
        this.newsecret = 'sqlite new secret';
    }
}
exports.GlobalSQLite = GlobalSQLite;
//# sourceMappingURL=GlobalSQLite.js.map